<template>
  <el-dialog
    title="切换班级"
    :visible.sync="dialogVisible"
    width="672px"
    center="center"
  >
    <div class="content flex">
      <div
        class="son"
        v-for="(item, index) in this.classList"
        :key="index"
        @click="cutClass(item)"
      >
        <div><img src="../../assets/app_img/icon_class.png" alt="" /></div>
        <span>{{ item.class_name }}</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-refresh-left"
        @click="dialogVisible = false"
        >创建班级</el-button
      >
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-circle-plus-outline"
        @click="dialogVisible = false"
        >加入班级</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  inject: ["reload"], //注入
  data() {
    return {
      dialogVisible: false,
      classList: "",
    };
  },
  updated() {},
  methods: {
    myCallBack() {
      // ...
      this.reload(); //局部刷新
    },
    async cutClassData() {
      const res = await this.$axios.post("/base/class/list");
      if (res.status == 200 && res.data.errCode == 0) {
        this.classList = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    },
    async cutClass(item) {  
      const res = await this.$axios.post("/base/class/choose", {
        class_id: item.class_id,
        course_id: item.courses[0].id,
      });
      if (res.status == 200 && res.data.errCode == 0) {
        window.localStorage.setItem("class_id", res.data.data.class_id);
        window.localStorage.setItem("course_id", res.data.data.course_id);
        window.localStorage.setItem("class_name", res.data.data.class_name);
        window.localStorage.setItem("course_name", res.data.data.course_name);
        window.localStorage.setItem("cate", res.data.data.cate);
        this.dialogVisible = false;
        window.location.reload();
      } else {
        this.$message.error(res.data.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  text-align: center;
}
/deep/ .el-dialog__title {
  font-weight: bold;
}
.flex {
  display: flex;
  justify-content: space-around;
  // flex-flow: row nowrap;
}
.content {
  width: 670px;
  text-align: center;
  img {
    margin-top: 30px;
    width: 30px;
    height: 30px;
  }
  .son {
    width: 130px;
    height: 112px;
    background: #f4f4f5;
    margin: 10px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/addClass.vue